(function () {
  'use strict';

  function debounce(fn, wait) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  document.querySelectorAll('.bsb-plp').forEach((root) => {
    const sectionId = root.dataset.sectionId;
    const inertedElements = new Map();
    let lastFocusedElement = null;

    function isMobileFilters() {
      return window.matchMedia('(max-width: 900px)').matches;
    }

    function setBackgroundInert(panel, isInert) {
      if (!isInert) {
        inertedElements.forEach((state, element) => {
          element.inert = state.inert;
          if (state.ariaHidden == null) {
            element.removeAttribute('aria-hidden');
          } else {
            element.setAttribute('aria-hidden', state.ariaHidden);
          }
        });
        inertedElements.clear();
        return;
      }

      let protectedChild = panel;
      while (protectedChild && protectedChild !== document.body) {
        const parent = protectedChild.parentElement;
        if (!parent) break;

        Array.from(parent.children).forEach((child) => {
          if (child === protectedChild || inertedElements.has(child)) return;
          inertedElements.set(child, {
            inert: child.inert,
            ariaHidden: child.getAttribute('aria-hidden'),
          });
          child.inert = true;
          child.setAttribute('aria-hidden', 'true');
        });
        protectedChild = parent;
      }
    }

    function focusPanel(panel) {
      const closeButton = panel.querySelector('.bsb-plp__facets-close');
      if (closeButton) closeButton.focus();
    }

    function announceResults() {
      const count = root.querySelector('#bsb-plp-facets-count');
      const status = root.querySelector('[data-bsb-plp-results-status]');
      if (!count || !status) return;
      status.textContent = '';
      window.requestAnimationFrame(() => {
        status.textContent = `${count.textContent.trim()} shown.`;
      });
    }

    function sortVariantCards() {
      if (root.dataset.cardMode === 'product') return;

      const selectedSort = root.querySelector('.bsb-plp__facets-sort-input:checked');
      const sortValue = selectedSort && selectedSort.value;
      if (sortValue !== 'title-ascending' && sortValue !== 'title-descending') return;

      const grid = root.querySelector('.bsb-plp__grid');
      if (!grid) return;

      const direction = sortValue === 'title-ascending' ? 1 : -1;
      const cards = Array.from(grid.querySelectorAll('[data-bsb-plp-card]'));
      cards.sort((a, b) => {
        const variantName = (a.dataset.variantName || '').localeCompare(
          b.dataset.variantName || '',
          undefined,
          { sensitivity: 'base', numeric: true }
        );
        if (variantName) return variantName * direction;

        const productName = (a.dataset.productName || '').localeCompare(
          b.dataset.productName || '',
          undefined,
          { sensitivity: 'base', numeric: true }
        );
        if (productName) return productName * direction;

        return (Number(a.dataset.variantId) - Number(b.dataset.variantId)) * direction;
      });

      cards.forEach((card) => grid.append(card));

      Array.from(grid.querySelectorAll('[data-bsb-plp-promo]'))
        .sort((a, b) => Number(a.dataset.promoPosition) - Number(b.dataset.promoPosition))
        .forEach((promo) => {
          const position = Number(promo.dataset.promoPosition);
          const card = cards[position - 1];
          if (card) {
            card.insertAdjacentElement('afterend', promo);
          } else {
            grid.append(promo);
          }
        });
    }

    function currentParams() {
      const params = new URLSearchParams();
      root.querySelectorAll('.bsb-plp__facet-input:checked').forEach((input) => {
        params.append(input.name, input.value);
      });
      const sort = root.querySelector('.bsb-plp__facets-sort-input:checked');
      if (sort && sort.value) params.set('sort_by', sort.value);
      return params;
    }

    function refresh(pushHistory, searchOverride, scrollToTop) {
      const search = searchOverride != null ? searchOverride : currentParams().toString();
      const url = `${window.location.pathname}?section_id=${sectionId}${search ? '&' + search : ''}`;

      root.classList.add('bsb-plp--loading');

      fetch(url)
        .then((res) => res.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector(`.bsb-plp[data-section-id="${sectionId}"]`);
          if (!fresh) return;

          const wasOpen = !!root.querySelector('#bsb-plp-facets-panel.active');
          if (wasOpen) {
            setPanelOpen(false, { returnFocus: false });

            const freshPanel = fresh.querySelector('#bsb-plp-facets-panel');
            const freshOverlay = fresh.querySelector('#bsb-plp-facets-overlay');
            const freshWrap = fresh.querySelector('.bsb-plp__facets-wrap');
            const freshToggle = fresh.querySelector('#bsb-plp-facets-toggle');
            if (freshPanel) {
              freshPanel.classList.add('active');
              freshPanel.setAttribute('aria-hidden', 'false');
              if (isMobileFilters()) {
                freshPanel.setAttribute('role', 'dialog');
                freshPanel.setAttribute('aria-modal', 'true');
              }
            }
            if (freshOverlay) freshOverlay.classList.add('active');
            if (freshWrap) freshWrap.classList.add('bsb-plp__facets-wrap--panel-open');
            if (freshToggle) {
              freshToggle.setAttribute('aria-expanded', 'true');
              const freshLabel = freshToggle.querySelector('.bsb-plp__facets-toggle-label');
              if (freshLabel) freshLabel.textContent = freshLabel.dataset.labelHide;
              const freshIcon = freshToggle.querySelector('.bsb-plp__facets-toggle-icon');
              if (freshIcon) freshIcon.classList.add('active');
            }
          }
          root.innerHTML = fresh.innerHTML;
          root.classList.remove('bsb-plp--loading');

          sortVariantCards();
          if (window.bsbRefreshPlpCardRows) window.bsbRefreshPlpCardRows();

          if (wasOpen) setPanelOpen(true, { silent: true });
          announceResults();

          if (pushHistory) {
            const newUrl = `${window.location.pathname}${search ? '?' + search : ''}`;
            history.pushState({ bsbPlp: true, search }, '', newUrl);
          }

          if (scrollToTop && !(window.Shopify && window.Shopify.designMode)) {
            root.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        })
        .catch(() => {
          root.classList.remove('bsb-plp--loading');
        });
    }

    const debouncedRefresh = debounce(() => refresh(true), 200);

    sortVariantCards();

    function setPanelOpen(isOpen, options = {}) {
      const { returnFocus = true, silent = false } = options;
      const toggle  = root.querySelector('#bsb-plp-facets-toggle');
      const panel   = root.querySelector('#bsb-plp-facets-panel');
      const overlay = root.querySelector('#bsb-plp-facets-overlay');
      const wrap    = root.querySelector('.bsb-plp__facets-wrap');
      if (!toggle || !panel) return;
      if (isMobileFilters()) {
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
      } else {
        panel.removeAttribute('role');
        panel.removeAttribute('aria-modal');
      }
      if (isOpen && isMobileFilters()) {
        lastFocusedElement = document.activeElement !== document.body
          ? document.activeElement
          : toggle;
        setBackgroundInert(panel, true);
      }
      panel.classList.toggle('active', isOpen);
      panel.setAttribute('aria-hidden', String(!isOpen));
      if (overlay) overlay.classList.toggle('active', isOpen);
      if (wrap) wrap.classList.toggle('bsb-plp__facets-wrap--panel-open', isOpen);
      document.body.classList.toggle('bsb-plp__filters-open', isOpen);
      toggle.setAttribute('aria-expanded', String(isOpen));
      const label = toggle.querySelector('.bsb-plp__facets-toggle-label');
      if (label) {
        label.textContent = isOpen ? label.dataset.labelHide : label.dataset.labelShow;
      }
      const icon = toggle.querySelector('.bsb-plp__facets-toggle-icon');
      if (icon) {
        icon.classList.toggle('active', isOpen);
      }
      if (!isOpen) {
        setBackgroundInert(panel, false);
        if (returnFocus && lastFocusedElement && document.body.contains(lastFocusedElement)) {
          lastFocusedElement.focus();
        }
        lastFocusedElement = null;
      } else if (isMobileFilters() && !silent) {
        window.requestAnimationFrame(() => focusPanel(panel));
      }
    }

    function closePanel() {
      setPanelOpen(false);
    }

    function setSortOpen(isOpen) {
      const toggle = root.querySelector('#bsb-plp-sort-toggle');
      const panel  = root.querySelector('#bsb-plp-sort-panel');
      if (!toggle || !panel) return;
      panel.classList.toggle('active', isOpen);
      toggle.setAttribute('aria-expanded', String(isOpen));
    }

    function closeSort() {
      setSortOpen(false);
    }

    // Delegated (not bound to specific elements) so it keeps working after
    // refresh() replaces root.innerHTML with freshly-fetched markup.
    root.addEventListener('click', (e) => {
      if (e.target.closest('.bsb-plp__facets-close')) {
        closePanel();
        return;
      }

      if (e.target.closest('#bsb-plp-facets-toggle')) {
        const panel = root.querySelector('#bsb-plp-facets-panel');
        if (!panel) return;
        closeSort();
        setPanelOpen(!panel.classList.contains('active'));
        return;
      }

      if (e.target.closest('#bsb-plp-sort-toggle')) {
        const panel = root.querySelector('#bsb-plp-sort-panel');
        if (!panel) return;
        closePanel();
        setSortOpen(!panel.classList.contains('active'));
      }
    });

    document.addEventListener('click', (e) => {
      const panel = root.querySelector('#bsb-plp-facets-panel');
      if (panel && panel.classList.contains('active') &&
          !e.target.closest('#bsb-plp-facets-panel') && !e.target.closest('#bsb-plp-facets-toggle')) {
        closePanel();
      }

      const sortPanel = root.querySelector('#bsb-plp-sort-panel');
      if (sortPanel && sortPanel.classList.contains('active') &&
          !e.target.closest('#bsb-plp-sort-panel') && !e.target.closest('#bsb-plp-sort-toggle')) {
        closeSort();
      }
    });

    document.addEventListener('keydown', (e) => {
      const panel = root.querySelector('#bsb-plp-facets-panel');
      const isPanelOpen = panel && panel.classList.contains('active');
      if (isPanelOpen && isMobileFilters() && e.key === 'Tab') {
        const focusable = Array.from(panel.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter((element) => !element.hidden);
        if (focusable.length) {
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (!panel.contains(document.activeElement) || (e.shiftKey && document.activeElement === first)) {
            e.preventDefault();
            (e.shiftKey ? last : first).focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
        return;
      }

      if (e.key !== 'Escape') return;
      if (isPanelOpen) closePanel();
      const sortPanel = root.querySelector('#bsb-plp-sort-panel');
      if (sortPanel && sortPanel.classList.contains('active')) closeSort();
    });

    root.addEventListener('change', (e) => {
      if (e.target.classList.contains('bsb-plp__facet-input')) {
        debouncedRefresh();
      }

      if (e.target.classList.contains('bsb-plp__facets-sort-input')) {
        const current = root.querySelector('#bsb-plp-sort-current');
        if (current) current.textContent = e.target.dataset.label || e.target.value;
        closeSort();
        debouncedRefresh();
      }
    });

    // Pagination links and "Clear all" already carry the correct destination
    // query string (Shopify builds paginate.parts/next/previous from the
    // current filters/sort automatically; "Clear all" points at the bare
    // collection URL) — reuse it as-is instead of reconstructing it, so it
    // can't drift out of sync with currentParams().
    root.addEventListener('click', (e) => {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      const filterRemovalLink = e.target.closest(
        '.bsb-plp__facets-clear[href], .bsb-plp__facets-active-remove[href], .bsb-plp__facets-active-clear[href], .bsb-plp__chip[href]'
      );
      if (filterRemovalLink) {
        e.preventDefault();
        closePanel();
        const target = new URL(filterRemovalLink.getAttribute('href'), window.location.origin);
        refresh(true, target.search.replace(/^\?/, ''), false);
        return;
      }

      const pageLink = e.target.closest('.pagination a[href]');
      if (!pageLink) return;
      const href = pageLink.getAttribute('href');
      if (!href) return;
      e.preventDefault();
      const target = new URL(href, window.location.origin);
      refresh(true, target.search.replace(/^\?/, ''), true);
    });

    window.addEventListener('popstate', () => {
      if (!document.body.contains(root)) return;
      refresh(false, window.location.search.replace(/^\?/, ''));
    });
  });
})();
